(function() {
  // Reservado para futuras customizações
})();

// Fix progress bar labels visibility in cart drawer
document.addEventListener('click', function() {
  setTimeout(function() {
    document.querySelectorAll('*').forEach(function(el) {
      if (el.className && typeof el.className === 'string' && el.className.indexOf('rewards-tiers') !== -1) {
        el.style.setProperty('overflow', 'visible', 'important');
      }
    });
  }, 300);
});

document.addEventListener('DOMContentLoaded', function() {
  function injectSizeGuide() {
    if (document.querySelector('.size-guide-btn')) return;

    const optionDiv = document.querySelector('#swatch-option2');
    if (!optionDiv) return;

    const sizeGuideContent = document.querySelector('[data-size-guide-content]')?.innerHTML;
    if (!sizeGuideContent) return;

    // Cria o modal
    const modal = document.createElement('div');
    modal.id = 'size-guide-modal';
    modal.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;align-items:center;justify-content:center;';
    modal.innerHTML = `
      <div style="background:#fff;width:90%;max-width:700px;max-height:90vh;border-radius:8px;overflow-y:auto;position:relative;padding:40px 24px 24px;">
        <button onclick="document.getElementById('size-guide-modal').style.display='none'"
          style="position:absolute;top:12px;right:16px;font-size:24px;background:none;border:none;cursor:pointer;">&times;</button>
        ${sizeGuideContent}
      </div>
    `;
    document.body.appendChild(modal);

    // Cria o botão
    const btn = document.createElement('button');
    btn.className = 'size-guide-btn';
    btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="vertical-align:middle;margin-right:5px;"><rect x="2" y="7" width="20" height="10" rx="2"/><line x1="6" y1="7" x2="6" y2="12"/><line x1="10" y1="7" x2="10" y2="10"/><line x1="14" y1="7" x2="14" y2="12"/><line x1="18" y1="7" x2="18" y2="10"/></svg><span style="text-decoration:underline;font-weight:400;">Tabulka velikostí</span>`;
    btn.style.cssText = 'font-size:0.8em;color:rgb(0,0,0);background:none;border:none;cursor:pointer;white-space:nowrap;padding:0;position:absolute;top:28px;left:0;';
    btn.onclick = () => document.getElementById('size-guide-modal').style.display = 'flex';

    optionDiv.style.position = 'relative';
    optionDiv.style.setProperty('align-items', 'flex-start', 'important');
    optionDiv.appendChild(btn);

    const swatchSingle = optionDiv.querySelector('.swatch-single');
    if (swatchSingle) swatchSingle.style.setProperty('margin-top', '32px', 'important');
  }

  injectSizeGuide();
  setTimeout(injectSizeGuide, 500);
  setTimeout(injectSizeGuide, 1500);
});
